import React from 'react'
import styled from 'styled-components'
import { Link } from 'react-router-dom'
import YoutubeLogo from '../img/logo.png';
import HomeIcon from "@mui/icons-material/Home";
import ExploreOutlinedIcon from "@mui/icons-material/ExploreOutlined";
import SubscriptionsOutlinedIcon from "@mui/icons-material/SubscriptionsOutlined";
import VideoLibraryOutlinedIcon from "@mui/icons-material/VideoLibraryOutlined";
import HistoryOutlinedIcon from "@mui/icons-material/HistoryOutlined";
import LibraryMusicOutlinedIcon from "@mui/icons-material/LibraryMusicOutlined";
import SportsEsportsOutlinedIcon from "@mui/icons-material/SportsEsportsOutlined";
import SportsBasketballOutlinedIcon from "@mui/icons-material/SportsBasketballOutlined";
import MovieOutlinedIcon from "@mui/icons-material/MovieOutlined";
import ArticleOutlinedIcon from "@mui/icons-material/ArticleOutlined";
import LiveTvOutlinedIcon from "@mui/icons-material/LiveTvOutlined";
import AccountCircleOutlinedIcon from "@mui/icons-material/AccountCircleOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FlagOutlinedIcon from "@mui/icons-material/FlagOutlined";
import HelpOutlineOutlinedIcon from "@mui/icons-material/HelpOutlineOutlined";
import SettingsBrightnessOutlinedIcon from "@mui/icons-material/SettingsBrightnessOutlined";
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch, useSelector } from 'react-redux';
import { logout } from '../redux/userSlice';
import { useNavigate } from 'react-router-dom';
import { ToastContainer,toast } from 'react-toastify';

const Container = styled.div`
    flex: 1;
    background-color:${({ theme }) => theme.bgLighter};
    height: 100vh;
    overflow-x: hidden;
    overflow-y: scroll;
    color: ${({ theme }) => theme.text};
    font-size:14px;
    position:sticky;
    top:0;
    @media (max-width: 1041px) {
        position: fixed;
        /* left: 100%; */
        left:${(props) => props.toggle ? "0" : "-200%"};
        height: 100vh;
        z-index: 5;
    }
`;
const Wrapper = styled.div`
    padding: 18px 26px;
`;
const Logo = styled.div`
    display:flex;
    align-items:center;
    gap:5px;
    font-weight:bold;
    margin-bottom:25px;
`
const Img = styled.img`
    height:25px;
`
const Item = styled.div`
    display:flex;
    align-items:center;
    gap:20px;
    cursor:pointer;
    padding: 7.5px 0px;
    
    &:hover{
        background-color: ${({ theme }) => theme.soft};
    }
`
const Hr = styled.hr`
    margin: 15px 0px;
    border: 0.5px solid ${({ theme }) => theme.soft};
`
const Login = styled.div``;
const Button = styled.button`
    padding: 5px 15px;
    background-color: transparent;
    border: 1px solid #3ea6ff;
    color: #3ea6ff;
    border-radius: 3px;
    font-weight:500;
    margin-top:10px;
    cursor:pointer;
    display:flex;
    align-items:center;
    gap:5px;
`
const Title = styled.h2`
  font-size: 14px;
  font-weight: 500;
  color: #aaaaaa;
  margin-bottom: 20px;
`;

const Menu = ({ darkMode, setDarkMode, toggle }) => {
    const { currentUser } = useSelector((state) => state.user);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleLogout = () => {
        dispatch(logout());
        navigate('/');
    }
    const updateMessage = () =>{
        toast.warn("Section Updating On Progress!",{
            position: "bottom-right",
        });
    }
    return (

        <Container toggle={toggle}>
            <Wrapper>
                <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                    <Logo>
                        <Img src={YoutubeLogo} />
                        Youtube
                    </Logo>
                </Link>
                <Link to="/" style={{ textDecoration: "none", color: "inherit" }}>
                    <Item>
                        <HomeIcon />
                        Home
                    </Item>
                </Link>
                <Link to="/trends" style={{ textDecoration: "none", color: "inherit" }}>
                    <Item>
                        <ExploreOutlinedIcon />
                        Explore
                    </Item>
                </Link>
                <Link to="/subscription" style={{textDecoration: "none", color: "inherit"}}>
                    <Item>
                        <SubscriptionsOutlinedIcon />
                        Subscriptions
                    </Item>
                </Link>

                <Hr />
                <Item onClick={updateMessage}>
                    <VideoLibraryOutlinedIcon />
                    Library
                </Item>
                <Item onClick={updateMessage}>
                    <HistoryOutlinedIcon />
                    History
                </Item>
                <Hr />
                {!currentUser && (
                    <>
                        <Login>
                            Sign in to like videos, comment, and subscribe.
                            <Link to="/signin" style={{ textDecoration: "none" }}>
                                <Button>
                                    <AccountCircleOutlinedIcon />
                                    SIGN IN
                                </Button>
                            </Link>
                        </Login>
                        <Hr />
                    </>
                )}

                <Title>BEST OF YOUTUBE</Title>
                <Item onClick={updateMessage}>
                    <LibraryMusicOutlinedIcon />
                    Music
                </Item>
                <Item onClick={updateMessage}>
                    <SportsBasketballOutlinedIcon />
                    Sports
                </Item>
                <Item onClick={updateMessage}>
                    <SportsEsportsOutlinedIcon />
                    Gaming
                </Item>
                <Item onClick={updateMessage}>
                    <MovieOutlinedIcon />
                    Movies
                </Item>
                <Item onClick={updateMessage}>
                    <ArticleOutlinedIcon />
                    News
                </Item>
                <Item onClick={updateMessage}>
                    <LiveTvOutlinedIcon />
                    Live
                </Item>
                <Hr />
                <Item onClick={updateMessage}>
                    <SettingsOutlinedIcon />
                    Settings
                </Item>
                <Item onClick={updateMessage}>
                    <FlagOutlinedIcon />
                    Report
                </Item>
                <Item onClick={updateMessage}>
                    <HelpOutlineOutlinedIcon />
                    Help
                </Item>
                {currentUser && (
                    <Item onClick={handleLogout}>
                        <LogoutIcon />
                        Logout
                    </Item>
                )}
                <Item onClick={() => setDarkMode(!darkMode)}>
                    <SettingsBrightnessOutlinedIcon />
                    {darkMode ? "Light" : "Dark"} Mode
                </Item>
            </Wrapper>
            <ToastContainer />
        </Container >
    )
}

export default Menu